import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppClientConfigurationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class AutoWeighingService {

  constructor(private appServerAPI: AppServerAPI,
              private configurationService: AppClientConfigurationService) {

  }

  public readWeight(sourceIdentifier: string): Observable<any> {

    return this.appServerAPI.execute(this.configurationService.getPropertyValue('client.io.yardconnector.url', null) + '/provider/weighing', {
      libra: sourceIdentifier
    });

  }
}
